// extracted by mini-css-extract-plugin
export var promotionLink = "_w0-0";